exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-20a07ee0] .el-form-item__content .el-select{width:100%!important}.table-header[data-v-20a07ee0]{border:1px solid #dcdfe6;text-indent:10px;color:#363636;background-color:#f5f5f5}", ""]);

// exports
